module.exports = __webpack_public_path__ + "img/banner-accessibility.736f1b67.jpg";